export const languagesDone = [
  {
    name: "Javascript",
    percentDone: 90,
  },
  {
    name: "ReactJs",
    percentDone: 90,
  }, 
  {
    name: "ReduxJs",
    percentDone: 90,
  },
  {
    name: "NodeJs",
    percentDone: 90,
  },
  {
    name: "Express",
    percentDone: 90,
  },
  {
    name: "NestJs",
    percentDone: 80,
  },
  {
    name: "NextJs",
    percentDone: 80,
  },

];

export const projectImage = [
  'asset/project/portfolio.png',
  'asset/project/expense-tracker-img.jpeg',
  'asset/project/real-time-chat-img.png',
  'asset/project/realtime-deshboard-img.png',
  'asset/project/student-management-img.png',
  'asset/project/dateing-app-img.jpg',
  'asset/project/shipp-management-img.png'
];
